import each from 'lodash/each'
import isNil from 'lodash/isNil'
import moment from 'moment'

import ApiObject from '../ApiObject'
import DateUtils from '../../utils/DateUtils'

import AvailabilityDate from './AvailabilityDate'

export default class AvailabilityDates extends ApiObject {

  add(fromDate, toDate) {
    this.dates = this.dates || []
    this.dates.push(
      new AvailabilityDate().fromJson({
        fromDate,
        toDate,
      })
    )
  }

  isAvailableForDate(date) {
    date = moment.isMoment(date) ? date : moment(date)

    const isAvailable = this.dates.filter(availabilityDate => date.isBetween(availabilityDate.fromDate, availabilityDate.toDate))

    return isAvailable.length
  }

  /**
   * api expects directly an array of AvailabilityDate
   */
  toJSON() {
    const json = super.toJSON()

    if (!isNil(json['dates'])) {
      return json['dates'].map(availabilityDate => ({
        fromDate: availabilityDate.fromDate.valueOf(),
        toDate: availabilityDate.toDate.valueOf(),
      }))
    }

    return null
  }

  postJsonAssignation(data) {
    super.postJsonAssignation(data)

    this.dates = []

    each(data, availabilityDateData => {
      const availabilityDate = new AvailabilityDate().fromJson(availabilityDateData)
      this.dates.push(availabilityDate)
    })
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/AvailabilityDates.js